import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subject} from 'rxjs';
import {SharedImports} from '@shared/shared-imports';
import {StepperModule} from 'primeng/stepper';
import {Page1ContactComponent} from '@app/public/campaigns/page-1-contact/page-1-contact.component';
import {Page4ConfirmComponent} from '@app/public/campaigns/page-4-confirm/page-4-confirm.component';
import {Page3AddressComponent} from '@app/public/campaigns/page-3-address/page-3-address.component';
import {Page2BillingComponent} from '@app/public/campaigns/page-2-billing/page-2-billing.component';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {SOICampaignsService} from '@services/soi-campaigns.service';
import {takeUntil} from 'rxjs/operators';
import {SOICampaignModel} from '@app/models/soi-campaigns.model';

@Component({
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss'],
  imports: [SharedImports, StepperModule, Page1ContactComponent, Page4ConfirmComponent, Page3AddressComponent, Page2BillingComponent]
})
export class PublicCampaignsComponent implements OnInit, OnDestroy, AfterViewInit {
  logo: string;
  tenant: string;
  active: number | undefined = 1;
  campaignId: string;
  stepOneComplete: boolean = false;
  stepTwoComplete: boolean = false;
  stepThreeComplete: boolean = false;
  campaignProfile = {} as UserSOICampaignDonationModel;
  orgCampaignDetails = {} as SOICampaignModel;
  private ngUnsubscribe = new Subject();

  constructor(private route: ActivatedRoute, private soiCampaignService: SOICampaignsService) {
  }

  ngOnInit() {
    this.campaignId = this.route.snapshot.paramMap.get('id');
  }

  ngAfterViewInit() {
    this.soiCampaignService.getUnauthSOICampaign(this.campaignId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.orgCampaignDetails = res;
          this.campaignProfile.CustomAttributes = [];
          this.orgCampaignDetails.CustomAttributes.forEach(attribute => {
            this.campaignProfile.CustomAttributes.push({
              CustomFieldID: attribute.CustomFieldID,
              DataTypeEnum: attribute.DataTypeEnum,
              FieldName: attribute.FieldName,
              Value: null,
              OrganizationID: this.orgCampaignDetails.OrganizationID,
              Required: attribute.Required,
            });
          });
        }, error: (e) => {
          console.debug(e);
        }
      });
  }

  ngOnDestroy() {
  }

}
